import {
  Component,
  OnInit,
  QueryList,
  ViewChildren,
  output
} from "@angular/core";
import {
  IMenuItemContainer,
  MENU_ITEM_CONTAINER_TOKEN,
  MenuItemComponent,
} from "../../../../modules/shared/components";

@Component({
  selector: "app-share-link-schedule",
  templateUrl: "./schedule.component.html",
  styleUrls: ["./schedule.component.scss"],
  providers: [
    {
      provide: MENU_ITEM_CONTAINER_TOKEN,
      useExisting: ShareLinkScheduleComponent,
    },
  ],
  standalone: false,
})
export class ShareLinkScheduleComponent implements OnInit, IMenuItemContainer {
  readonly request = output<void>();

  @ViewChildren(MenuItemComponent) menuItems: QueryList<MenuItemComponent>;

  constructor() {}

  ngOnInit(): void {}

  getMenuItems(): MenuItemComponent[] {
    return this.menuItems.toArray();
  }

  callbackRequest() {
    this.request.emit();
  }
}
